import { closeForm } from '@/store/module/scheduler/mutation/closeForm';
import { openForm } from '@/store/module/scheduler/mutation/openForm';

export const mutations = {
	closeForm,
	openForm
};
